import object from '@mailobj-browser/front/js/utils/object.js'

// const _props = new WeakMap()
/* current state of the meet page */
const _meetProps = {}
/* immutable state of the page */
const _scopeProps = {}

export const states = object(null, {
  init: 'init',
  wait: 'wait',
  accept: 'accept',
  connect: 'connect',
  stopping: 'stopping',
  ended: 'ended'
})

export const setState = (state) => {
  if (!Object.hasOwn(states, state)) {
    throw new Error("bad state provided: " + state)
  }
  const props = meetProps()
  props.st = state
}

export const propsReset = () => {
  Object.assign(_meetProps,
    {
      uri: "",
      f: false,
      atts: [],
      atts_cancel: [],
      join: 0,
      caller: null,
      organizer: null,
      dial: null,
      ws: null
    })
}

export const meetProps = () => {
  //return _props.get(meetFragment())
  if (!_meetProps.st) {
    propsReset()
    _meetProps.st = states.init
  }
  return _meetProps
}

export const setOrganizer = (name) => {
  const props = meetProps()
  props.organizer = name
}

export const scopeProps = () => {
  return _scopeProps
}

export const setScope = (props) => {
  Object.keys(_scopeProps).forEach(key => delete _scopeProps[key])
  Object.assign(_scopeProps, props)
}
